import { render } from "./HeaderCarouselImagePreview.vue?vue&type=template&id=39b30c58&scoped=true"
import script from "./HeaderCarouselImagePreview.vue?vue&type=script&lang=js"
export * from "./HeaderCarouselImagePreview.vue?vue&type=script&lang=js"

import "./HeaderCarouselImagePreview.vue?vue&type=style&index=0&id=39b30c58&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b30c58"]])

export default __exports__